import { apiClient } from '@/lib/api/api-client'
import { ItemLocation } from '../types/item-location'

const ITEM_LOCATION_ENDPOINT = '/itemlocations'

export const itemLocationApi = {
  getItemLocation: (id: string) => {
    return apiClient.get<ItemLocation[]>(`${ITEM_LOCATION_ENDPOINT}/item/${id}`)
  },

  createItemLocation: (payload: any) => {
    return apiClient.post<any>(`${ITEM_LOCATION_ENDPOINT}/record`, payload)
  },
}
